var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagesPerOreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.051,
    height: 88.762,
    viewBox: "0 0 77.051 88.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6639",
    "data-name": "Group 6639",
    transform: "translate(-401 -470)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9173",
    "data-name": "Path 9173",
    d: "M23.419,43.164S9.748,52.192,7.18,61.8l-2.209.539S5.524,44.472,17.812,37.45c3.775-2.157,1.676-3.6.077-4.392S6.615,27.382,4.971,8.223c0,0,14.151,4.366,36.726,0,0,0-1.185,18.844-12.751,24.758-5.124,2.62-.321,4.34.475,4.726s5.419,3.673,7.4,7.6l3.056-1.258s-3.046-5.909-7.448-8.77c-.77-.5.231-.732,1.156-1.477s10.889-9.4,11.3-26.915c0,0,10.127-4.672-15.7-6.69C16.849-.766-6.612,1.854,1.863,6.9c0,0,.621,18.781,11.75,27.313,1.156.886,1.262.722.135,1.435S2.67,44.286,1.889,63.03c-.026.616-2.928.925-1.49,3.018s13.3,3.942,18.646,3.685l.038-17.888L31.7,48.66a29.539,29.539,0,0,0-8.281-5.5",
    transform: "translate(401 470)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9174",
    "data-name": "Path 9174",
    d: "M120.583,81.137S116.326,89.015,100.7,92.7l6.068,5.663s9.891-7.445,13.82-17.23",
    transform: "translate(317.762 402.929)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9175",
    "data-name": "Path 9175",
    d: "M177.049,228.864l-17.6-10.169s-17.478,11.4-38.319,15.564v7.376l1.243,1.262-1.281.366v7.444l1.04,1.012-1.156,1.135v7.1l15.892,9.592s14.98-1.026,40.186-16.334v-7.2l-.936-.654.936-.964v-6.934l-1.522-.439,1.522-1.045Zm-34.638,1.484,11.615,6.858c-1.964,1.059-14.215,4.467-14.215,4.467l-11.693-6.355a144.941,144.941,0,0,0,14.293-4.97m12.52,31.339c-1.579.77-17.008,5.431-17.008,5.431l-14.234-8.359.071-3.916,14.125,7.806c5.932-.5,17.046-5.239,17.046-5.239Zm-15.98-3.365-15.262-8.935.087-3.842,15.034,8.108s9.1-1.316,16.27-4.859l.128,4.289Zm16.289-14.434c-1.522.848-16.122,5.22-16.122,5.22l-15.236-8.9V236.3l15.294,8.361c5.664-.463,16.257-4.913,16.257-4.913ZM150.61,227.17a76.718,76.718,0,0,0,9.015-5.5l11.967,7.167c-1.874,1.643-9.554,5.436-9.554,5.436Zm12.763,17.951s9.093-4.391,10.942-5.676l.128,4.239s-7.86,4.6-11.071,5.83Zm11.436,6.511s-8.784,5.586-11.693,6.529v-4.372s11.057-5.721,11.693-6.3Zm.135-17.4s-8.039,5.341-11.083,6.125l-.076-4.315s10.49-5.239,11.159-5.92Z",
    transform: "translate(301.002 289.217)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9176",
    "data-name": "Path 9176",
    d: "M256.648,298.521l-8.63-5.046c-1.636,6.74,8.63,5.046,8.63,5.046",
    transform: "translate(196.125 227.4)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9177",
    "data-name": "Path 9177",
    d: "M303.191,270.18l7.936,4.675s-1.233-4.982-7.936-4.675",
    transform: "translate(150.371 246.669)",
    fill: "#1d3943"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesPerOreIcon);
export default __webpack_public_path__ + "static/media/PagesPerOreIcon.f1426e1ba8dd27749d4391bfcb2920e6.svg";
export { ForwardRef as ReactComponent };